import { WSIcons } from "../../commonFunctions/iIcons";

export const getMenu: any = (userType: string) => {
  return {
    staticMenu:
      userType === "admin"
        ? [
          {
            id: 1,
            label: "Home",
            icon: WSIcons.Home,
            path: "/home"
          },
          {
            id: 2,
            label: "Masters",
            icon: WSIcons.Masters,
            children: [
              {
                id: 8,
                label: "Banners",
                path: "/banner/list"
              },

              {
                id: 9,
                label: "Top Brands",
                path: "/brand/list"
              },

              {
                id: 10,
                label: "Products",
                path: "/product/list"
              },

              {
                id: 11,
                label: "Reward rules",
                path: "/reward/rule/list"
              },

              {
                id: 14,
                label: "Redeem Now",
                path: "/reward/redeem"
              },

              {
                id: 12,
                label: "Customers",
                path: "/digital/card"
              },

              {
                id: 13,
                label: "Promotions",
                path: "/promotion/list",
              },
            ]
          },
          {
            id: 3,
            label: "Users",
            icon: WSIcons.UserGroup,
            path: "/user/list"
          },
        ]
        : [
          {
            id: 1,
            label: "Home",
            icon: WSIcons.Home,
            path: "/home"
          },
          {
            id: 11,
            label: "Reward rules",
            icon: WSIcons.RolesIcon,
            path: "/reward/rule/list"
          },

          {
            id: 14,
            label: "Redeem Now",
            icon: WSIcons.PrizeIcon,
            path: "/reward/redeem"
          },

          {
            id: 12,
            label: "Customers",
            icon: WSIcons.PeopleIcon,
            path: "/digital/card"
          },
        ]
  };
};
